import React from 'react';

import style from './intro.module.scss';

export const Intro = () => {
    return (
        <div className={style.intro}>
            <div className={style.introGroup}>
                <p className={style.introTitle}>The Highest Quality O-Rings Available When You Need Them</p>

                <p className={style.introContent}>
                    With one of the manufacturer and distributor of o-rings and related seals in North China, we're
                    committed to providing the right product at the right price to every customer. Our technical sales
                    team is experienced and knowledgeable about o-rings and their application. Because of this, we
                    provide customers with guidance that ensures the optimal solution.
                </p>
            </div>

            <div className={style.introGroup}>
                <p className={style.introTitle}>O-Ring Material</p>

                <p className={style.introContent}>
                    Material matters. Due to this, selecting an o-ring material for a specific application is dependent
                    on many criteria, including what's being sealed, temperature range, pressure, dynamic or static
                    service, desired service life, installation considerations, tolerances, and many more. General
                    purpose compounds are used broadly, however, utilizing the exact compound consistently is equally as
                    important.
                </p>
            </div>
        </div>
    );
};
